import {
    LOADING,
    SUCCESS,
    ERROR,
} from '@/shared/constants/loadingStatuses.constants';

export default {
    LOAD_BOOT_START(state) {
        state.boot.status = LOADING;
        state.boot.error = null;
    },

    LOAD_BOOT_SUCCESS(state, { featureFlags, locale }) {
        state.boot.status = SUCCESS;
        state.boot.error = null;
        state.locale = locale;

        // This is so we maintain the reactivity of the featureFlags state object
        Object.entries(featureFlags).forEach(([key, value]) => {
            state.featureFlags[key] = value;
        });
    },

    LOAD_BOOT_ERROR(state, error) {
        state.boot.status = ERROR;
        state.boot.error = error;
    },
};
